import { Injectable, Signal, signal, TemplateRef, WritableSignal } from '@angular/core';

export interface SideContainerInterface<T> {
  template: TemplateRef<T>;
  context: T;
  placement?: 'top' | 'middle' | 'bottom',
  hasBackdrop?: boolean;
  disableClose?: boolean;
}

@Injectable({ providedIn: 'root' })
export class SidenavService<T> {
  readonly content: Signal<SideContainerInterface<T>>;
  readonly opened: Signal<boolean>;

  private _content: WritableSignal<SideContainerInterface<T>> = signal<SideContainerInterface<T>>(null);
  private _opened: WritableSignal<boolean> = signal(false);

  constructor() {
    this.content = this._content.asReadonly();
    this.opened = this._opened.asReadonly();
  }

  setContent(portal?: SideContainerInterface<T>): void {
    this._content.set(portal);
  }

  open(): void {
    this._opened.set(true);
  }

  close(): void {
    this._opened.set(false);
  }
}
